<template>
  <div>
    <div class="father">
      <div>
        <h1>Main heading</h1>
        <h2>Sub heading</h2>
      </div>
      <div>
        <article>
          <img src="../../../static/img/关于宏邦1.jpg" />
          <h2></h2>
          <div class="content_div">
            <p class="num_title">01</p>
            <p class="title">企事业餐饮服务</p>
            <p>
              宏邦餐饮服务是宁波宏邦保安旗下产业之一，专业为企业、工厂、单位团体提供一站式膳食经营管理餐饮服务。秉承创新美食文化的理念，严格坚守食品健康安全，严苛遵循HACCP管理体系规范操作，为广大企事业单位员工提供丰富健康营养的膳食和细致周到的服务。提高了员工就餐体验，改善员工福利及提高企业员工归属感；同时，简化了企事业单位的工作章程，协助企业控制成本，解决很多企业在后勤瓶颈问题，助力企业更高效的投入到运营管理中去。
            </p>
            <p class="click_more" @click="navto('/Food')">查看详情</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/关于宏邦2.jpg" />
          <div class="content_div">
            <p class="num_title">02</p>
            <p class="title">人防技防安保服务</p>
            <p>
              宁波宏邦保安服务有限公司是经浙江省公安厅批准，宁波市公安局监管，并于工商行政管理机构合法注册，从事现代安防业的综合服务供应商；是宁波市一家新型的专业化、规范化、科学化、现代化的服务型企业，提供人防、物防、技防、联网报警、非武装押运等安防相关的一站式服务。
            </p>
            <p class="click_more" @click="navto('/Safe')">查看详情</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/关于宏邦3.jpg" />
          <div class="content_div">
            <p class="num_title">03</p>
            <p class="title">物业管理服务</p>
            <p>
              宁波宏邦保安服务有限公司主要承接餐饮管理、保安服务、日常保洁等专项服务及托管服务。凭借专业的服务资质和经验秉承细心、贴心的服务理念，不断提升物业服务质量，向国际物业管理服务标准看齐，为每一位业主提供细致周到的服务。
            </p>
            <p class="click_more" @click="navto('/Service')">查看详情</p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {
    navto(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style lang="stylus" scoped>
.father {
  width: 100%;
  height: 50vh;
  margin: 5rem auto;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  * {
    transition: all 0.3s ease 0s;
  }

  .content_div {
    height: 100%;
    width: 100%;
    background: var(--textBlue60);
    position: absolute;
    padding:4rem 4rem;
    top: 0;

    h3 {
      margin: 10rem 0 0 10rem;
      font-size: 3rem;
      font-family: bold;
    }

    .num_title {
      font-size: 7.3rem;
      font-family: number;
      // margin-bottom:4rem;
    }

    .title {
      font-size: 2.3rem;
      font-family: regular;
    }

    .click_more {
      cursor:pointer;
      margin-top:5rem;
      border: 1px solid white;
      width: fit-content;
      padding: 0.5rem 2rem;
    }

    p {
      margin: 0 10rem 0 10rem;
      width: auto;
      font-size: 1.4rem;
      font-family: light;
    }

    .first_p {
      margin: 10rem 10rem 0 10rem;
    }
  }

  /* Background colours */
  div + div article:nth-child(1) {
    // background: #00c22326;
    // background-image: url('../../static/img/切片-38.jpg');
    background-repeat: no-repeat;
  }

  div + div article:nth-child(2) {
    // background: #f37338;
    // background-image: url('../../static/img/切片-39.jpg');
  }

  div + div article:nth-child(3) {
    // background: #fdb632;
    // background-image: url('../../static/img/切片-40.jpg');
  }

  div + div article:nth-child(4) {
    // background: #027878;
    // background-image: url('../../static/img/切片-41.jpg');
  }

  div + div article:nth-child(5) {
    // background: #801638;
    // background-image: url('../../static/img/切片-42.jpg');
  }

  div + div article:nth-child(6), div + div {
    // background: #800000;
    // background-image: url('../../static/img/切片-43.jpg');
    // height:100%;
    // background-repeat: no-repeat;
  }

  /* Main layout */
  html, body, div + div {
    width: 100%;
    height: 100%;
  }

  div + div {
    list-style: none;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    overflow: hidden;
  }

  /* Articles */
  div + div article {
    flex: initial;
    width: 35%;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    vertical-align: bottom;
    box-sizing: border-box;
    // padding: 2vh 1vw;
    position: relative;
  }

  /* Big Headings */
  div:first-child {
    display: none;
    position: fixed;
    bottom: 8vh;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    z-index: 2;
  }

  div:first-child h1, div:first-child h2 {
    margin: 0;
    padding: 0;
  }

  /* Hover interaction */
  div + div:hover article {
    flex: initial;
    width: 20%;
  }

  div + div article:hover {
    width: 60%;
  }

  article > div {
    opacity: 0;
    transition: opacity 0.2s ease 0;
  }

  div + div article:hover > div {
    opacity: 1;
    transition: opacity 0.3s ease 0.3s;
  }

  /* navigation */
  div + div article > h2 {
    bottom: 2vh;
    position: absolute;
    text-align: center;
    width: 100%;
    margin: 0;
    font-size: 3vh;
  }

  /* Article layouts */
  article div {
    text-align: left;
    width: 58vw;
  }

  article div p, article div div h2, article div h3 {
    margin: 0 0 1em 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
  }

  article div p {
    width: 40vw;
  }

  @media (min-width: 1300px) {
    .litter_line {
      margin: 4rem 5rem 1rem 5rem;
    }

    .content_div {
      h3 {
        margin: 5rem 0 0 5rem;
      }

      p {
        margin: 0 5rem 0 5rem;
      }

      .first_p {
        margin: 5rem 5rem 0 5rem;
      }
    }
  }

  @media (max-width: 900px) {
    div + div article {
      padding: 2vh 3vw;
    }

    div + div article > h2 {
      transform: rotate(90deg);
      bottom: 23vh;
      min-width: 12em;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: 0 0 0;
      opacity: 1;
    }

    div + div article:hover > h2 {
      opacity: 0;
    }

    article div p {
      width: 50vw;
    }

    article div {
      max-height: calc(72%);
      overflow-y: auto;
    }
  }
}
</style>